import React, { Fragment } from 'react'
import MEModal from '../../components/MEModal'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Button,
  MenuItem,
} from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { saveNewSectionName } from '../actions'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

class EditSectionNameModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      editNameModalOpen: false,
      editedSectionName: this.props.sectionName,
    }
    this.toggleEditSectionNameModal = this.toggleEditSectionNameModal.bind(this)
    this.handleEditSectionName = this.handleEditSectionName.bind(this)
    this.submitEditSectionName = this.submitEditSectionName.bind(this)
  }

  toggleEditSectionNameModal() {
    this.setState({
      editNameModalOpen: !this.state.editNameModalOpen,
    })
  }

  handleEditSectionName(e) {
    this.setState({
      editedSectionName: e.target.value,
    })
  }

  async submitEditSectionName() {
    let data = this.props.filters
    data.section_name = this.state.editedSectionName
    data.section_id = this.props.section
    data.pageNum = this.props.currentCourseMemPage
    data.archivedPageNum = this.props.currentArchivePage
    this.toggleEditSectionNameModal()
    let response = await this.props.sendEditedSection(data)
    if (response.status === 200) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Section Updated"
            content="Successfully updated the section name."
            scheme={Cinnamon.Crisp.SCHEME_GREY}
          />
        ),
      })
    } else {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={`There was an error trying to save your new section name: ${response.data.error}`}
            scheme={Cinnamon.Crisp.SCHEME_RED}
          />
        ),
      })
    }
  }

  render() {
    return (
      <Fragment>
        <MenuItem
          onClick={this.toggleEditSectionNameModal}
          className="me-list-item"
        >
          <div className="fal fa-pencil-alt mr-2 fa-fw color_teal" />
          Edit Section Name
        </MenuItem>
        <MEModal
          show={this.state.editNameModalOpen}
          close={this.toggleEditSectionNameModal}
          title="Edit Section Name"
        >
          <form onSubmit={e => e.preventDefault()}>
            <p>
              Enter a new name for the section below. Signup links and other
              information will not be affected.
            </p>
            <FormGroup>
              <ControlLabel>Section Name</ControlLabel>
              <FormControl
                type="text"
                onChange={this.handleEditSectionName}
                value={this.state.editedSectionName}
              />
            </FormGroup>
            <Button
              className="btn-myed btn-primary-myed"
              type="button"
              bsStyle="primary"
              onClick={this.submitEditSectionName}
            >
              Submit
            </Button>
          </form>
        </MEModal>
      </Fragment>
    )
  }
}

EditSectionNameModal.propTypes = {
  section: PropTypes.string,
  sectionName: PropTypes.string,
  sendEditedSection: PropTypes.func,
  filters: PropTypes.object,
}

const mapStateToProps = state => {
  return {
    filters: state.filters,
    currentCourseMemPage: state.currentCourseMemPage,
    currentArchivePage: state.currentArchivePage,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    sendEditedSection: sectionData => {
      let response = dispatch(saveNewSectionName(sectionData))
      return response
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditSectionNameModal)
